// eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
const enabled = process.env.NODE_ENV !== 'production';

const addTestId = (id) => (enabled ? { 'data-testid': id } : {});

export default addTestId;
